import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const flowStats = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows-stats`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}